import Reveal from "@/components/Reveal";

export default function PageIntro({ index, title, description, aside, titleTestId, descriptionTestId }) {
  return (
    <section className="page-intro">
      <div className="shell page-intro-grid">
        <Reveal>
          <div className="page-intro-meta">{index} / Ashwini Patil</div>
          <h1 className="page-title" data-testid={titleTestId || `page-title-${index}`}>{title}</h1>
        </Reveal>
        <Reveal className="page-intro-aside" delay={130}>
          <p className="page-intro-copy" data-testid={descriptionTestId}>{description}</p>
          {aside && <p className="page-intro-aside-note">{aside}</p>}
        </Reveal>
      </div>
    </section>
  );
}
